/** Timeline View Component
 */

"use strict";

var Marionette = require("marionette");
var App = require("app");
var _ = require("lodash");

var Tabs = require("src/behaviors/tabs");
var TabBehavior = require("src/behaviors/tabs");

// module.exports.layout = Marionette.View.extend({
//   template: require('./templates/layout.html'),
//   triggers: {
//   },
//   className: 'page page__client',
//   regions: {
//     headerRegion: '.header-region',
//     contentRegion: '.body-region',
//     tabLabels: '.nav-tabs'
//   },
//   behaviors: {
//     TabBehavior: {
//       behaviorClass: TabBehavior.Behavior,
//       tabsRegion: 'tabLabels'
//     }
//   },
//   onBeforeRender: function () {}
// })

// ------------ //
var PageLayout = Marionette.View.extend({
  template: require("./templates/layout.html"),
  className: "page",
  events: {
    "click .js-header-button": "onHeaderButtonClick"
  },
  initialize: function() {
    // if the pagemodel has tabs, add them to the options so the tabs behavior can access them
    if (_.has(this.options.pageModel.attributes, "tabs")) {
      this.setTabs(_.get(this.options.pageModel.attributes, "tabs"));
    }

    // if the pageModel changes re-render the thabs
    this.listenTo(this.options.pageModel, "change", function() {
      this.setTabs(_.get(this.options.pageModel.attributes, "tabs"));
      this.render();
    });
  },
  setTabs: function(tabs) {
    var tabsSet = [];
    this.options.tabs = false;

    _.forEach(tabs, function(tab) {
      tabsSet.push(new Tabs.Model(tab));
    });
    this.options.tabs = new Tabs.Collection(tabsSet);
  },
  onHeaderButtonClick: function(ev) {
    if (!ev.currentTarget) return false;

    var button = ev.currentTarget;
    var action = button.getAttribute("data-action");
    this.trigger(action, this);
    // console.log(action)
  },
  regions: {
    bodyRegion: ".body-region",
    tabsRegion: ".header-tabs-region",
    filterRegion: ".filter-region",
    headerDetailsRegion: ".page-header-details__region"
  },
  behaviors: {
    TabBehavior: {
      behaviorClass: TabBehavior.Behavior,
      tabsRegion: "tabsRegion"
    }
  },
  templateContext: function() {
    var self = this;
    return {
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getPageModel: function() {
        return _.get(self.options, "pageModel.attributes");
      },
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      userHasRole: App.TemplateHelpers.userHasRole
    };
  }
});

//
var LayoutPageTabs = PageLayout.extend({
  regions: {
    bodyRegion: ".body-region",
    tabsRegion: ".page-tabs-region",
    filterRegion: ".filter-region",
    headerDetailsRegion: ".page-header-details__region"
  }
});

module.exports.Layout = PageLayout;
module.exports.LayoutHeaderTabs = PageLayout;
module.exports.LayoutPageTabs = LayoutPageTabs;



// WEBPACK FOOTER //
// ./js/components/page-view/index.js